import script from "./Ask.vue?vue&type=script&setup=true&lang=js"
export * from "./Ask.vue?vue&type=script&setup=true&lang=js"

import "./Ask.vue?vue&type=style&index=0&id=6363d1f7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6363d1f7"]])

export default __exports__